<template>
  <div class="upload_">
    <div class="title_">
      营业执照
    </div>

    <cube-upload
      ref="upload"
      class="idcard_upload_"
      v-model="files"
      @file-submitted="submitted"
      @file-error="errHandler"
    >
      <div class="clear-fix">
        <cube-upload-file
          v-for="(file, i) in files"
          :file="file"
          :key="i"
        ></cube-upload-file>
        <cube-upload-btn :multiple="false">
          <div class="card_" v-if="files.length == 0">
            <div class="up_icon_">
              <span>＋</span>
            </div>
            <p>营业执照正面</p>
          </div>
          <img class="img_" v-else :src="files[files.length - 1] && files[files.length - 1].url" />
        </cube-upload-btn>
      </div>
    </cube-upload>
    <div class="careful_">请上传图片，文件大小不超过4M,仅支持JPG/PNG/BMP格式文件类型,最短边最少15PX,最长边最大4096PX
      <p>注：请完整拍摄营业执照正面，避免出现模糊/缺角/过曝等问题</p>
    </div>
    <cube-button class="btn_" @click="handleNext">下一步</cube-button>
    <cube-popup type="my-popup" :mask="false" ref="myPopup" :position="position">
      <div style="font-size: 14px;line-height: 24px;color: #fff;width: 200px;background-color: rgba(0,0,0,.7);text-align: left;padding: 10px;">
        {{errMsg}}
      </div>
    </cube-popup>
  </div>
</template>

<script>
import api from '@/utils/api'
import options from "./options";
import common from './common.js'
export default {
  data() {
    document.title = '注册'
    return {
      files: [],
      data:{},
      formInfo:{},
      fileSize: '',
      fileType: '',
      maxSize: 4194304,  // b  4M
      errMsg: '上传营业执照名称与所填渠道名称不一致，请重新上传。温馨提示：请使用无水印的营业执照上传，如果仍存在问题请联系平台管理员',
      position: 'center'
    };
  },
  mounted(){
    this.formInfo = this.getSession('f_')
  },
  methods: {
    ...common,
    inviteUploadFile(data){
      api.inviteUploadFile(data).then(res => {
        this.data = res.data
      })
    },
    showPopup() {
      const component = this.$refs.myPopup
      component.show()
      setTimeout(() => {
        component.hide()
      }, 3000)
    },
    handleNext(){
      if(this.checkFile()){
        this.setSession('u_',this.data.url)
        this.$router.push({name: 'loginInfo',query:{cporpa:'1'}})
      }
    },
    checkFile(){
      if (this.fileSize > this.maxSize) {
        this.showToast('文件大小最大支持4M')
        return false
      }
      if(this.fileType.toUpperCase() != 'JPG' && this.fileType.toUpperCase() != 'PNG' && this.fileType.toUpperCase() != 'BMG') {
        this.showToast('文件类型仅支持PNG/JPG/BMG格式')
        return false
      }
      if(this.formInfo.channelName != this.data.title){
        this.showPopup()
        return false
      }
      return true
    },
    submitted(file){
      this.fileSize = file.size
      if (file.size > this.maxSize) {
        this.showToast('文件大小最大支持4M')
        return false
      }
      let index = file.name.lastIndexOf('.')
      let fileType = file.name.substr(index + 1,file.name.length - 1)
      this.fileType = fileType
      if(fileType.toUpperCase() != 'JPG' && fileType.toUpperCase() != 'PNG' && fileType.toUpperCase() != 'BMG') {
        this.showToast('文件类型仅支持PNG/JPG/BMG格式')
        return false
      }
      let formData = new FormData()
      formData.append('file', file.file, file.name)
      this.inviteUploadFile(formData)
    },
    errHandler(file) {
      // const msg = file.response.message
      this.$createToast({
        type: "warn",
        txt: "Upload fail",
        time: 1000
      }).show();
    }
  }
};
</script>

<style lang="scss" scoped>
.upload_ {
  font-family: PingFangSC-Regular, PingFang SC;
  background: #fafafa;
  width: 100%;
  .up_icon_ {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    font-size: 32px;
    line-height: 1;
    font-style: normal;
    color: #fff;
    background-color: #0079fe;
    border-radius: 50%;
  }

  .cube-upload-file {
    display: none;
  }
  .card_ {
    width: 80%;
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border: 1px #0079fe dotted;
    margin: 0 auto;
    border-radius: 6px;
    font-size: 12px;
    p {
      margin-top: 20px;
    }
  }
  .img_ {
    width: 80%;
    height: 150px;
    margin: 0 auto;
    border-radius: 6px;
  }
  .btn_ {
    background: rgba(27, 124, 248, 1);
    font-size: 16px;
    font-weight: bold;
    border-radius: 6px;
    margin: 20px auto;
    color: #fff;
    width: 90% !important;
  }
}
.careful_ {
  margin-top: 10px;
  font-size: 12px;
  padding: 0 25px;
  line-height: 24px;
  text-align: left;
  color: #666;
}
</style>
